import { useApi } from "@utils/useApi";
import { StorefrontClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";

import ms from "ms";
import { TOP_NAV_MENU_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";

export default function useGetTopNavMenu() {
  const api = useApi(StorefrontClient);

  const fetch = async () => {
    return await api.getTopNavMenuItems();
  };

  return useQuery({
    queryKey: [TOP_NAV_MENU_QUERY_KEY],
    queryFn: fetch,
    cacheTime: ms("30m")
  });
}
